import { HttpClient, HttpParams } from '@angular/common/http';
import { Injectable } from '@angular/core';
import { NgbModal } from '@ng-bootstrap/ng-bootstrap';
import { BehaviorSubject, Observable } from 'rxjs';
import { map } from 'rxjs/operators';
import { IndustryContentModalComponent } from './industry-content-modal/industry-content-modal.component';
import { OeAppService } from './oe-app.service';
import { IndustryTagDto } from './types/IndustryTagDto';
import { StudyBundleCourseDto } from './types/StudyBundleCourseDto';

@Injectable({ providedIn: 'root' })
export class IndustryContentService {
  private _selectedIndustries = new BehaviorSubject<Array<IndustryTagDto>>(null);
  private _industriesTagList = new BehaviorSubject(new Array<IndustryTagDto>());

  constructor(private http: HttpClient, private oeAppService: OeAppService, private modalService: NgbModal) {
    this.getIndustries(this.oeAppService.courseServiceHost).subscribe((industries) =>
      this._industriesTagList.next(industries)
    );
    this.getSelectedIndustries(
      this.oeAppService.courseServiceHost,
      this.oeAppService.getPersonData().contactId
    ).subscribe((selectedIndustries) => this._selectedIndustries.next(selectedIndustries));
  }

  get selectedIndustries$(): Observable<Array<IndustryTagDto>> {
    return this._selectedIndustries.asObservable();
  }

  get publishedIndustries$() {
    return this._industriesTagList
      .asObservable()
      .pipe(map((industries) => industries.filter((industry) => industry.published)));
  }

  get comingSoonIndustries$() {
    return this._industriesTagList
      .asObservable()
      .pipe(map((industries) => industries.filter((industry) => !industry.published)));
  }

  getIndustries(courseServiceHost: string): Observable<Array<IndustryTagDto>> {
    const params: HttpParams = new HttpParams().set('tagType', 'INDUSTRY');
    return this.http.get<Array<IndustryTagDto>>(`${courseServiceHost}/v1/tags`, { params });
  }

  getSelectedIndustries(courseServiceHost: string, contactId: string): Observable<Array<IndustryTagDto>> {
    const params: HttpParams = new HttpParams().set('tagType', 'INDUSTRY').set('contactId', contactId);
    return this.http.get<Array<IndustryTagDto>>(`${courseServiceHost}/v1/person-tags`, { params });
  }

  saveSelectedIndustries(industries: Array<IndustryTagDto>) {
    const payload = {
      tagNames: industries.map((industry) => industry.name),
      tagType: 'INDUSTRY',
      contactId: this.oeAppService.getPersonData().contactId,
    };
    this._selectedIndustries.next(industries);
    this.http.post(`${this.oeAppService.courseServiceHost}/v1/person-tags`, payload).subscribe();
  }

  openActivity(course: StudyBundleCourseDto, shouldSaveTime = false) {
    const modalRef = this.modalService.open(IndustryContentModalComponent, {
      size: 'lg',
      backdrop: 'static',
      keyboard: false,
    });
    modalRef.componentInstance.course = course;
    modalRef.componentInstance.shouldSaveTime = shouldSaveTime;
  }
}



// WEBPACK FOOTER //
// ./ts/app/shared/industry-content.service.ts